import {RootState} from '../../store';
import {NotificationSubscription} from './types';

export const selectionSelector = (state: RootState): Record<string, NotificationSubscription> =>
    state['notification-subscriptions'].selection;
